module.exports = __webpack_public_path__ + "media/packs/src/assets/images/edit-lesson-note-icon-18f63a68b624c2880832080396980c24.svg";